<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('trajectory.Time')">
              <el-date-picker
                v-model="queryDateTime"
                :end-placeholder="$t('operationCenter.endDate')"
                :picker-options="pickerOptions"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <!--州 -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.state')">
              <el-select
                v-model="queryForm.params.stateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
                @change="handleGetSiteList"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 网点 -->
          <el-col :span="5">
            <el-form-item :label="$t('GlobalSetObj.Outlets')">
              <el-select
                v-model="queryForm.params.siteIdList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="btnSearch(1)"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="btnSearch(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                size="small" @click="allExportOrder"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ color: 'black' }"
      :span-method="objectSpanMethod"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('collectionCenter.state')"
        align="center"
        min-width="120"
        prop="regionOrStateName"
      />
      <el-table-column :label="$t('GlobalSetObj.Outlets')" min-width="120" prop="stateOrSiteName" />
      <el-table-column
        :label="$t('tablePrice.monthToDate')"
        min-width="120"
        prop="currentMonthFalseSignCount"
      />
      <el-table-column
        :label="$t('tablePrice.dailyAverage')"
        min-width="120"
        prop="avgOfSearchDay"
      />
      <el-table-column :label="$t('GlobalSetObj.sum')" align="center">
        <el-table-column
          :label="$t('tablePrice.falseDeliveryCount')"
          min-width="150"
          prop="falseSignCount"
        />
        <el-table-column
          :label="$t('tablePrice.deliveryCount')"
          min-width="150"
          prop="signedCount"
        />
        <el-table-column
          :label="$t('tablePrice.falseDeliveryRate')"
          min-width="150"
          prop="signRate"
        />
      </el-table-column>
      <el-table-column
        v-for="item in columnList" :key="item.id" :label="item.label"
        align="center"
      >
        <el-table-column
          :label="$t('tablePrice.falseDeliveryCount')"
          :prop="item.falseSignCount"
          min-width="150"
        />
        <el-table-column
          :label="$t('tablePrice.deliveryCount')"
          :prop="item.signedCount"
          min-width="150"
        />
        <el-table-column
          :label="$t('tablePrice.falseDeliveryRate')"
          :prop="item.signRate"
          min-width="150"
        />
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.dayOverDay')"
        align="center"
        min-width="120"
        prop="dailyComparison"
      >
        <template slot-scope="scope">
          <div :style="{ color: scope.row.dailyComparisonStyle ? '#009c37' : 'red' }">
            {{ scope.row.dailyComparison || '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.weekOverWeek')"
        align="center"
        min-width="120"
        prop="weeklyComparison"
      >
        <template slot-scope="scope">
          <div :style="{ color: scope.row.weeklyComparisonStyle ? '#009c37' : 'red' }">
            {{ scope.row.weeklyComparison || '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.monthOverMonth')"
        align="center"
        min-width="120"
        prop="monthlyComparison"
      >
        <template slot-scope="scope">
          <div :style="{ color: scope.row.monthlyComparisonStyle ? '#009c37' : 'red' }">
            {{ scope.row.monthlyComparison || '--' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="getCurrentTableData"
        @size-change="getSizeTableData"
      />
    </div>
  </div>
</template>

<script>
import { getLgAreaListData, selectInfoByStateTwo } from '@/api/orderApi';
import dayjs from 'dayjs';
import {
  failSignReportExport,
  falseSignDailyReportSitePage,
  falseSignDailyReportSiteSummary,
  getSiteByState
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ReturnDataMonitoring',
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          type: 0,
          stateList: [],
          siteIdList: []
        }
      },
      total: 0,
      StateList: [], // 州
      tableData: [],
      columnList: [],
      queryDateTime: [this.getAWeek().startDate, this.getAWeek().endDate],
      siteList: [],
      flattenedObject: {},
      resultObj: {},
      choiceDate0: '',
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const min = minTime;
          // const newDate = new Date(new Date().toLocaleDateString()).getTime();
          const newDate = ((d) => (d.setHours(0, 0, 0, 0), d.setDate(d.getDate() + 1), d.getTime()))(new Date());
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      }
    };
  },
  created() {
    // 获取加盟商选项
    this.getAddress();
    this.getSearch(1);
    this.getSiteList();
  },
  methods: {
    // 导出
    allExportOrder() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 0,
          regionOrState: this.queryForm.params.stateList,
          stateOrSite: this.queryForm.params.siteIdList,
          startTime: '',
          endTime: ''
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      failSignReportExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 搜索、重置
    btnSearch(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getSearch();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            stateList: [],
            siteIdList: []
          }
        };
        this.queryDateTime = [this.getAWeek().startDate, this.getAWeek().endDate];
        this.getSearch();
        this.getSiteList();
      }
    },
    // 获取最近30天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    },
    // 获取加盟商时效统计列表
    getSearch(val) {
      this.columnList = [];
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 0,
          regionOrState: this.queryForm.params.stateList,
          stateOrSite: this.queryForm.params.siteIdList,
          startTime: '',
          endTime: ''
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      falseSignDailyReportSitePage(data)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records;
            this.tableData[0].detailList.forEach((item, index) => {
              const data = {
                id: index,
                label: item.statTime,
                falseSignCount: 'falseSignCount' + index,
                signedCount: 'signedCount' + index,
                signRate: 'signRate' + index
              };
              this.columnList.push(data);
              // for (const key in item) {
              //   this.flattenedObject[`${key}${index}`] = item[key];
              // }
            });
            // this.resultObj = Object.assign({}, this.flattenedObject, res.data);
            const arr = this.tableData.map((item, index) => {
              const newItem = { ...item };
              delete newItem.detailList;
              item.detailList.forEach((detail, detailIndex) => {
                ['signedCount', 'signRate', 'falseSignCount'].forEach((key) => {
                  newItem[`${key}${String(detailIndex).padStart(1, '0')}`] = detail[key];
                });
              });
              return newItem;
            });
            this.tableData = arr;
            falseSignDailyReportSiteSummary(data.params).then((res) => {
              res.data.stateOrSite = this.$t('GlobalSetObj.Total');
              res.data.regionOrStateName = this.$t('GlobalSetObj.Total');
              const arr1 = [res.data];
              const arr2 = arr1.map((item, index) => {
                const newItem = { ...item };
                delete newItem.detailList;
                item.detailList.forEach((detail, detailIndex) => {
                  ['signedCount', 'signRate', 'falseSignCount'].forEach((key) => {
                    newItem[`${key}${String(detailIndex).padStart(1, '0')}`] = detail[key];
                  });
                });
                return newItem;
              });
              this.tableData.unshift(arr2[0]);
              this.tableData.forEach((item) => {
                item.dailyComparisonStyle = this.isPercentageGreaterThanZero(item.dailyComparison);
                item.weeklyComparisonStyle = this.isPercentageGreaterThanZero(item.weeklyComparison);
                item.monthlyComparisonStyle = this.isPercentageGreaterThanZero(
                  item.monthlyComparison
                );
              });
              this.getSpanArr(this.tableData);
            });
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    handleGetSiteList(val) {
      this.queryForm.params.siteIdList = [];
      console.log(val, 'handleGetSiteList');
      if (val.length > 0) {
        // const data = {
        //   states: val
        // };
        getSiteByState(val).then((res) => {
          if (res.code === 200) {
            this.siteList = res.data;
          }
        });
      } else {
        this.getSiteList();
      }
    },
    // 判断百分比是否大于零
    isPercentageGreaterThanZero(percentageStr) {
      const numberStr = percentageStr.replace('%', '');
      const number = parseFloat(numberStr) / 100;
      return number > 0;
    },
    // 获取网点列表
    getSiteList() {
      const data = {};
      selectInfoByStateTwo(data).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data.siteList;
        }
      });
    }
  }
};
</script>

<style scoped>
table {
  border: 1px solid black;
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}
</style>
